import { render } from "./TrailMakingB.vue?vue&type=template&id=38d1f959&scoped=true"
import script from "./TrailMakingB.vue?vue&type=script&lang=js"
export * from "./TrailMakingB.vue?vue&type=script&lang=js"

import "./TrailMakingB.vue?vue&type=style&index=0&id=38d1f959&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d1f959"]])

export default __exports__